import { ConfirmationModal, type ConfirmationModalProps, Text } from '@shared/components';

type ProctorRequestDeletionModalProps = Pick<
  ConfirmationModalProps,
  'open' | 'onClose' | 'onAccept' | 'onDiscard' | 'loading'
>;

export default function ProctorRequestDeletionModal(
  props: Readonly<ProctorRequestDeletionModalProps>,
) {
  const { open: isOpen, onClose, onAccept, onDiscard, loading } = props;

  return (
    <ConfirmationModal
      title='ลบแบบร่าง?'
      content={
        <Text>
          คุณกำลังจะลบแบบร่างคำขออนุมัติผู้คุมสอบ
          <br /> แบบร่างนี้จะถูกลบถาวรและไม่สามารถนำกลับมาได้อีก
        </Text>
      }
      variant='error'
      acceptText='ลบแบบร่าง'
      discardText='ยกเลิก'
      open={isOpen}
      onClose={onClose}
      onAccept={onAccept}
      onDiscard={onDiscard}
      loading={loading}
    />
  );
}
